import participants from './reducers/participants/participantsState';
import winners from './reducers/winners/winnersState';

const initialState = {
    participants,
    winners
};

export default initialState;